<!--操作日志-->
<template>
  <div class="border finance-log">
    <!-- <Tabs value="file" :animated='false'>
      <TabPane label="文件" name="file">
        <div style="padding:20px">
          <div class="border">
            <Row type="flex" class="file">
              <i-col span="12" class="text-center">文件名称</i-col>
              <i-col span="12" class="text-center">文件地址</i-col>
            </Row>
            <Row class="file" type="flex" v-for="(item, index) in inspectFiles" :key="index">
              <i-col span="12" class="text-center">{{item.fileName}}</i-col>
              <i-col span="12" class="text-center">{{item.url}}</i-col>
            </Row>
          </div>
        </div>
      </TabPane>
      <TabPane label="任务日志" name="log">
        <div style="padding:20px">
          <div class="border">
            <Row type="flex" class="file">
              <i-col span="6" class="text-center">操作任务</i-col>
              <i-col span="6" class="text-center">操作时间</i-col>
              <i-col span="6" class="text-center">操作人</i-col>
              <i-col span="6" class="text-center">备注</i-col>
            </Row>
            <Row class="file" type="flex" v-for="(item, index) in logList" :key="index">
              <i-col span="6" class="text-center">{{item.content}}</i-col>
              <i-col span="6" class="text-center">{{item.createTime}}</i-col>
              <i-col span="6" class="text-center">
                <Avatar>{{item.creatorName.slice(0,2)}}</Avatar>
              </i-col>
              <i-col span="6" class="text-center">{{item.reason}}</i-col>
            </Row>
          </div>
        </div>
      </TabPane>
    </Tabs> -->
    <el-timeline :reverse="reverse" class="time_line">
      <el-timeline-item
        v-for="(activity, index) in logList"
        color="#2D8EF8"
        size="large"
        :key="index"
      >
        {{ activity.createTime }}
        <div class="img-head">
          <Avatar>{{ activity.creatorName.slice(0, 2) }}</Avatar>
          &nbsp;&nbsp; <span>{{ activity.creatorName }}</span
        >
        </div>

        {{ activity.content }}
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script>
export default {
  props: {
    logList: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    inspectFiles: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      reverse: false,
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
      fileLog: {
        file: [
          {
            name: "哈哈哈",
            address: "河南省",
          },
        ],
        log: [
          {
            operate: "aa",
            time: "ss",
            name: "",
            remark: "",
          },
        ],
      },
    };
  },
};
</script>
<style lang="less" scoped>
.finance-log {
  padding: 16px 0 0px 25px;
  .el-timeline-item{
    top: 12px;
  }
}
.img-head {
  // margin: 0 30px;
  margin-left: 30px;
  width: 200px;
  display: inline-block;
}
/deep/.el-timeline-item__wrapper {
  top: -7px;
}
/deep/.el-timeline-item__node--large {
  // width: 22px;
  // height: 22px;
  background-image: radial-gradient(#2d8ef8 40%, #C1DEFC 50%);
}
.file {
  border-bottom: 1px solid #ced4da;
  .text-center {
    padding: 10px;
    text-align: center;
    border-right: 1px solid #ced4da;
    word-break: keep-all;
    word-wrap: break-word;
    &:last-child {
      border-right: none;
    }
  }
  &:first-child {
    background: #f1f3f5;
  }
  &:last-child {
    border-bottom: 0;
  }
}
.border {
  border: 1px solid #ced4da;
  border-radius: 5px;
}
</style>


